import { FetchResult } from '@apollo/client'
import { client } from '../../..'
import { RequestMeetingAsEmployeeMutation, RequestMeetingAsEmployeeMutationVariables, MeetingType } from '../../../types'
import { REQUEST_MEETING_AS_EMPLOYEE } from '../MeetingMutations'
import { MEETINGS_AND_REQUESTS_BY_REPLYER } from '../MeetingRequestQueries'

export default (): {
  requestMeeting: (
    meetingRequesterId: number,
    meetingReviewerId: number,
    meetingType: MeetingType,
    reasonForMeeting: string,
    context: 'OwnGrowth' | 'MyMeetings',
  ) => Promise<FetchResult<RequestMeetingAsEmployeeMutation>>
} => {
  const requestMeeting = async (
    meetingRequesterId: number,
    meetingReviewerId: number,
    meetingType: MeetingType,
    reasonForMeeting: string,
    context: 'OwnGrowth' | 'MyMeetings',
  ): Promise<FetchResult<RequestMeetingAsEmployeeMutation>> => {
    const refetchQueries =
      context === 'MyMeetings'
        ? [
            {
              query: MEETINGS_AND_REQUESTS_BY_REPLYER,
              variables: {
                replyerId: meetingRequesterId,
              },
            },
          ]
        : []

    return await client.mutate<RequestMeetingAsEmployeeMutation, RequestMeetingAsEmployeeMutationVariables>({
      mutation: REQUEST_MEETING_AS_EMPLOYEE,
      variables: {
        requesterId: meetingRequesterId,
        reviewerId: meetingReviewerId,
        meetingType: meetingType,
        meetingReason: reasonForMeeting,
      },
      refetchQueries,
      awaitRefetchQueries: refetchQueries.length > 0,
    })
  }

  return { requestMeeting }
}
